import VideoSection from '@/components/_organisms/VideoSection';
import FrontPinkButton from '@/components/buttons/primary/FrontPinkButton';
import Link from '@/components/Link';
import { ModuleVideoSectionFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import gtm from '@/lib/gtm';
import { getSingle, maybeNotSet } from '@/lib/typescript-helpers';
import { FC, ReactNode } from 'react';

export interface VideoSectionModuleProps {
  props: CraftModuleFragment<ModuleVideoSectionFragment>;
  ctaOverride?: ({ ctas }: { ctas: ReactNode }) => ReactNode;
}

const VideoSectionModule: FC<VideoSectionModuleProps> = ({ props, ctaOverride }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const video = getSingle(props?.video);
  const poster = getSingle(props?.videoCoverImage);
  const videoCta = getSingleLink(props.videoCta);
  const ctaText = maybeNotSet(videoCta?.text);

  const cta = videoCta ? (
    <Link href={videoCta.url}>
      <FrontPinkButton
        onClick={() => {
          gtm.track('click', {
            element_type: 'button',
            element_label: ctaText,
            location: 'Video Section',
          });
        }}
      >
        {ctaText}
      </FrontPinkButton>
    </Link>
  ) : undefined;

  return (
    <VideoSection
      heading={props.heading ?? undefined}
      headingOnTop={props.headingOnTop ?? true}
      videoSrc={video?.url ?? undefined}
      videoPosterSrc={poster?.url ?? undefined}
      youtubeVideoUrl={props.youtubeVideoUrl ?? undefined}
      hasSound={props.hasSound ?? false}
      cta={ctaOverride ? ctaOverride({ ctas: cta }) : cta}
    />
  );
};

export default VideoSectionModule;
